<div class="filters">
  <mat-form-field appearance="outline" class="search">
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="searchValue" (ngModelChange)="queueFilter($event)">
    @if (searchValue) {
      <button mat-icon-button matSuffix aria-label="Clear search" (click)="clearSearch()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
</div>

<div class="scroll-container">
  <table mat-table [dataSource]="tableDataSource" class="table" matSort>
    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Active</th>
      <td mat-cell *matCellDef="let product">{{product.active ? 'Active' : 'Archived'}}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let product">{{product.name}}</td>
    </ng-container>

    <ng-container matColumnDef="price">
      <th mat-header-cell *matHeaderCellDef>Price</th>
      <td mat-cell *matCellDef="let product">{{getPrice(product)}}</td>
    </ng-container>

    <ng-container matColumnDef="billingCycle">
      <th mat-header-cell *matHeaderCellDef>Billing Cycle</th>
      <td mat-cell *matCellDef="let product">{{getBillingCycleName(product.billingCycleId)}}</td>
    </ng-container>

    <ng-container matColumnDef="billingDay">
      <th mat-header-cell *matHeaderCellDef>Billing Day</th>
      <td mat-cell *matCellDef="let product">{{product.billingCycleId !== getFixedBillingId() ? '--' : (product.billingDay || '--')}}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let product" class="actions-cell">
        <button mat-icon-button [matMenuTriggerFor]="actionsMenu" [matMenuTriggerData]="{ product: product }">
          <mat-icon>more_vert</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
    <tr mat-row *matRowDef="let row; columns: columnNames"></tr>
  </table>
</div>

<mat-menu #actionsMenu="matMenu">
  <ng-template matMenuContent let-product="product">
    <button mat-menu-item (click)="openChangeCycleModal(product)">Change cycle</button>
    <button mat-menu-item (click)="openChangeDayModal(product)" [disabled]="product.billingCycleId !== getFixedBillingId()">
      Change Billing Day
    </button>
  </ng-template>
</mat-menu>
